/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Nilesh Pranami",
  title: "Hi all, I'm Nilesh",
  subTitle: emoji(
"An enthusiastic AI Engineer 🚀 with a passion for crafting innovative, scalable solutions. I specialize in using AI 🤖, data science 📊, and software engineering 💻 to build impactful products that solve real-world problems and drive change 🌍.",  ),
  resumeLink:
    "https://drive.google.com/file/d/1KCDR5SZeh2dicuhvNtf-20nO8dYIfzzy/view?usp=drive_link", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/NileshPranami",
  linkedin: "https://www.linkedin.com/in/nileshpranami/",
  gmail: "mailto:nileshpranami16@gmail.com",
  // github: "https://gitlab.com/saadpasta",
  // facebook: "https://www.facebook.com/saad.pasta7",
  // stackoverflow: "https://scholar.google.com/citations?hl=en&user=LpH1OiUAAAAJ",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "RELENTLESS MAD SCIENTIST OF AI, PUSHING THE LIMITS OF INTELLIGENCE—ONE ALGORITHM AT A TIME! 🚀🤖",
skills: [
    emoji("⚡ Developing and deploying Machine Learning & Deep Learning models"),
    emoji("⚡ Building NLP, Computer Vision, and Generative AI solutions"),
    emoji("⚡ Designing scalable data pipelines and AI-driven architectures"),
    emoji("⚡ Implementing MLOps for model training, deployment, and monitoring"),
    emoji("⚡ Cloud AI solutions with GCP and Azure"),
    emoji("⚡ Integrating AI models into real-world applications")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

 softwareSkills: [
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "tensorflow",
      fontAwesomeClassname: "fas fa-brain"
    },
    {
      skillName: "pytorch",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "scikit-learn",
      fontAwesomeClassname: "fas fa-robot"
    },
    {
      skillName: "deep learning",
      fontAwesomeClassname: "fas fa-network-wired"
    },
    {
      skillName: "NLP",
      fontAwesomeClassname: "fas fa-comment-dots"
    },
    {
      skillName: "computer vision",
      fontAwesomeClassname: "fas fa-eye"
    },
    {
      skillName: "big data",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "mongoDB",
      fontAwesomeClassname: "fas fa-leaf"
    },
    {
      skillName: "Hadoop",
      fontAwesomeClassname: "fas fa-server"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "GCP",
      fontAwesomeClassname: "fab fa-google"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "Kubernetes",
      fontAwesomeClassname: "fas fa-cubes"
    }
  ],

  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section
  schools: [
    // {
    //   schoolName: "Indian Institute of Technology Patna",
    //   logo: require("./assets/images/IITP.png"),
    //   subHeader: "M.Tech. in Artificial Intelligence and Data Science Engineering",
    //   duration: "2023 - 2025",
    //   desc: "Focused on AI, Machine Learning, and Data Science with a strong academic record (95% equivalent grade).",
    //   descBullets: [
    //     "Studied core subjects like Machine Learning, Deep Learning, NLP, and Data Structures.",
    //     "Completed specialized courses in Deep Learning, Cloud Computing, and Full Stack Development.",
    //     "Published research and worked on AI-driven industry projects."
    //   ],
    //   website_link: "https://www.iitp.ac.in/"
    // },
    {
      schoolName: "Bakhtiyarpur College of Engineering",
      logo: require("./assets/images/bce.png"),
      subHeader: "B.Tech in Computer Science and Engineering",
      duration: "2016 - 2020",
      desc: "Explored AI, Explainable AI, Graph Machine Learning, and Computer Vision.",
      descBullets: [
        "Worked on cutting-edge AI projects with national and international companies.",
        "Research intern at IIT Patna, contributing to NLP projects."
      ],
      website_link: "https://bcebakhtiyarpur.ac.in/"
    }
  ]
};


// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, // Show Proficiency Section
  experience: [
    {
      Stack: "LLM (Large Language Models)👾",
      color: "#4B5945" // Bold red for impact
    },
    {
      Stack: "AI Agents ⚛",
      color: "#605678" // Orange for innovation
    },
    {
      Stack: "Machine Learning 📊",
      color: "#E63946" // Bold red for impact
    },
    {
      Stack: "Deep Learning 🧠",
      color: "#F4A261" // Orange for innovation
    },
    {
      Stack: "Artificial Intelligence 🤖",
      color: "#2A9D8F" // Teal for intelligence
    },
    {
      Stack: "Natural Language Processing 🗣️",
      color: "#457B9D" // Blue for communication
    },
    {
      Stack: "Computer Vision 📸",
      color: "#FF4545" // Light cyan for vision
    },
    {
      Stack: "MLOps ⚙️",
      color: "#1D3557" // Dark blue for infrastructure
    },
    {
      Stack: "Cloud Computing ☁️",
      color: "#FFC107" // Yellow for cloud tech
    },
    {
      Stack: "Python 🐍",
      color: "#4CAF50" // Green for programming
    },
    {
      Stack: "SQL 🗄️",
      color: "#9C27B0" // Purple for databases
    },
    {
      Stack: "Android App Development 📱",
      color: "#8D77AB" // Purple for databases
    }
  ],
  displayCodersrank: false // Hide CodersRank badges
};




// Work experience section

const workExperiences = {
  display: true, // Set to true to show workExperiences Section
  experience: [
    {
        role: "Gen AI Engineer",
        company: "Cisco",
        companylogo: require("./assets/images/cisco_logo.png"),
        date: "May 2024 – Present",
        desc: "Developed AI-driven platforms and agent-based LLM workflows for Cisco's internal use.",
        descBullets: [
            "Standalone developer of a HuggingFace-like platform for dataset and AI model repository.",
            "Contributed to an agentic platform for LLM workflows using crewAI and Langchain.",
            "Designed a graphical interface for defining agents, tools, tasks, and workflows."
        ]
    },
    {
        role: "AI-ML Engineer",
        company: "Randstad Digital",
        companylogo: require("./assets/images/randstaddigital_logo.jpg"),
        date: "Nov 2023 – May 2024",
        desc: "Developed and deployed an HR chatbot using Generative AI, streamlining internal operations.",
        descBullets: [
            "Automated HR-related tasks, saving 15 hours per week.",
            "Integrated CI/CD pipeline for deployment on Google Cloud Platform."
        ]
    },
    {
        role: "Data Scientist",
        company: "Tata Consultancy Services",
        companylogo: require("./assets/images/tcs_logo2.png"),
        date: "Nov 2020 – Nov 2023",
        desc: "Developed ML models for medicine rating prediction, assessed data maturity for a major bank, and worked on a large-scale cloud migration project.",
        descBullets: [
            "Built ML models (LinearRegression, RandomForestRegressor, XGBRegression) for predicting medicine ratings.",
            "Served as Business Analyst in TCS DATOM project, assessing IT and analytics maturity for UniCredit Bank.",
            "Worked on a large-scale GCP migration, creating ETL pipelines using Apache Airflow, Dataflow, and SQL procedures."
        ]
    },
    {
        role: "NLP Research Intern",
        company: "Indian Institute of Technology, Patna",
        companylogo: require("./assets/images/IITP.png"),
        date: "May 2019 – Dec 2019",
        desc: "Developed a state-of-the-art scientific summarization model, improving performance metrics.",
        descBullets: [
            "Outperformed previous state-of-the-art models in scientific summarization by improving the ROUGE score by 16%.",
            "Applied NLP techniques for text summarization and information extraction."
        ]
    }
  ]

};


/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements and Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters, and Some Cool Stuff that I have done!",

  achievementsCards: [
    {
      title: "Smart India Hackathon",
      subtitle: "- Gov of India",
      image: require("./assets/images/SIH_logo.png"),
      imageAlt: "Coursera Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1SF8Jn2LBVW5kuaSC5MVyt3DLDk7RUdbC/view"
        }
      ]
    },
    {
      title: "World Youth Skill Day (Silver Medal)",
      subtitle: "- Gov of Bihar",
      image: require("./assets/images/Bihar_Government_Banner.png"),
      imageAlt: "Bihar Gov Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/drive/folders/105mcn3Imz8_MYyel9JA9vVUGtg-HR-Yo"
        }
      ]
    },
    {
      title: "Neural Networks and Deep Learning",
      subtitle: "- Andrew Ng",
      image: require("./assets/images/coursera_logo.png"),
      imageAlt: "Coursera Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.coursera.org/account/accomplishments/certificate/MWQG66KE93PS"
        }
      ]
    },
    {
      title: "Professional Machine Learning Engineer",
      subtitle: "- Google Cloud",
      image: require("./assets/images/google_cloud_logo.png"),
      imageAlt: "Google Cloud Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credential.net/39a8552a-40f9-40d1-b5ee-93164b9dde20#acc.40T2cKyW"
        }
      ]
    },
    {
      title: "Natural Language Processing (NLP)",
      subtitle: "- Karen Kocher",
      image: require("./assets/images/microsoft_logo.png"),
      imageAlt: "Microsoft Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://courses.edx.org/certificates/24ed0bb5f5c7486bbedb3bc94c8e9ebb"
        }
      ]
    },
    {
      title: "Advanced Deep Learning",
      subtitle: "- Mitesh Khapra & Pratyush Kumar (IIT-Madras)",
      image: require("./assets/images/one_fourth_labs_logo.jpg"),
      imageAlt: "One Fourth Labs Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://padhai.onefourthlabs.in/certificates/6ekhxpljav"
        }
      ]
    },
    {
      title: "Big Social Data Analysis",
      subtitle: "- Erik Cambria",
      image: require("./assets/images/gian.png"),
      imageAlt: "GIAN Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1FvpdIWYEoovt3ZKWOnRkJiUukSWbmhRx/view"
        }
      ]
    },
    {
      title: "Azure AI Fundamentals",
      subtitle: "- Microsoft",
      image: require("./assets/images/microsoft_logo.png"),
      imageAlt: "Microsoft Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credly.com/badges/6a192c12-bba8-4d95-ac7d-f34b94934175?source=linked_in_profile"
        }
      ]
    },
    {
      title: "Unsupervised Data Mining",
      subtitle: "- Stefan Kramar",
      image: require("./assets/images/gian.png"),
      imageAlt: "GIAN Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/17XE75Gs1NPxHs6bvEDUHDj0hycEk3irj/view?usp=drive_link"
        }
      ]
    },
    {
      title: "Natural Language Processing (NLP)",
      subtitle: "- Anna Potapenko & Alexey Zobnin",
      image: require("./assets/images/coursera_logo.png"),
      imageAlt: "Coursera Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.coursera.org/account/accomplishments/certificate/MWQG66KE93PS"
        }
      ]
    },
    {
      title: "AI From the Data Center to the Edge",
      subtitle: "- Scott Apeland",
      image: require("./assets/images/intel.png"),
      imageAlt: "Intel Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credential.net/1e64412d-d8c2-4bd9-9286-483d8a742aec#acc.i65x4LsQ"
        }
      ]
    },
    {
      title: "AWS Machine Learning Scholarship",
      subtitle: "- Sebastian Thrun",
      image: require("./assets/images/udacity.png"),
      imageAlt: "Udacity Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://s3-us-west-2.amazonaws.com/udacity-printer/production/certificates/a3271b12-87f2-4e13-9b4d-da923af8ea68.pdf?utm_campaign=sch_600_auto_ndxxx_aws-ml-completed_global&utm_source=blueshift&utm_medium=email&bsft_clkid=dd86962b-49d3-4be3-a5f3-d2d5d459f0"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};


// Blogs Section

const blogSection = {
  title: "Publications",
  subtitle:
    "With a passion for research and development, I love to share my published works and insights with the world.",
  displayMediumBlogs: "false", // Set false to use hardcoded publications
  blogs: [
    {
      url: "https://link.springer.com/chapter/10.1007/978-981-97-1757-6_40",
      title:
        "Personalized Navigation System: A Computer-Based System for Visually Impaired to Interact with Its Surroundings",
      description: "Paper published in Springer Nature."
    },
    {
      url: "https://link.springer.com/chapter/10.1007/978-981-97-1757-6_41",
      title: "Hajj Crowd Control for Better Management of Pilgrims",
      description: "Paper published in Springer Nature."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};


// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "NUMBER SYSTEM",
      subtitle: "Medium.com",
      slides_url: "https://medium.com/@nileshpranami/number-system-5a1641dddcfa"
    },
    {
      title: "Tech Industry in 2020",
      subtitle: "Medium.com",
      slides_url: "https://medium.com/@nileshpranami/tech-industry-in-2020-3e20c9db35ba"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",
 
  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+91-85073-79478",
  email_address: "nileshpranami16@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
